/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useState, useEffect, useRef } from 'react';
import {Navbar, Nav, Button} from 'react-bootstrap';
import { Link, useRouteMatch ,useHistory} from 'react-router-dom';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import { useStorage64Latin } from 'pages/Header/Content/hooks/useStorageBase64';
import ChangeGiftTable from 'components/gifts-table/ChangeGiftTable';
import { ShoppingCartPopover } from 'components/gifts-table/ShoppingCart';
import { useUserInfo } from 'pages/Header/Content/hooks/usePersonalData';
import { CURRENT_GIFT_TABLE, PROFILE_DATA } from 'constants/storage64';
import { encodeStorage, removeStorage } from 'functions/storageBase64';
import shoppingCartIcon from 'assets/img/compras.svg';
import setting from 'assets/img/frame.svg';
import iconHamburger from 'assets/img/icon_hamburger.svg';
import arrow from 'assets/img/select-arrow-open.svg';
import { useStore, withStore } from 'store';
import { setGiftTable } from 'store/actions/giftTable';
import ListGiftsRecived from 'components/Modal/ListGiftsRecived';
import { useWindowSize, useGiftTableInfo } from 'hooks';
import searchIcon from 'assets/img/search.svg'
import { MENU_LINKS } from './config';
import { SettingOptionPopover , SettingOptionPopoverMovi } from '../SettingOption';
import './style.scss';
// eslint-disable-next-line import/order
import ChangeGiftTableList from 'components/gifts-table/ChangeGiftTableList';
import { PrintQR } from 'components/Cards';


const HeaderMenuLink = ({ label, to, division }) => {
  const match = useRouteMatch({
    path: to,
    exact: false
  });

  const matchTwo = useRouteMatch({
    path: '/my-wallet',
    exact: true
  });

  const [getOpenModal, setOpenModal] = useState(false);

  const handleClickShare = () => {
    setOpenModal(true);
  };

  const handleCloseModal = (value) => {
    setOpenModal(false);
  };

  return (
    <li
      className={`${
        match || (matchTwo && to === '/regalos-recibidos') ? 'active' : ''
      } ${division ? 'division' : ''}`}
    >
   
      {to === '/compartir-mesa' ? (
        <Link to="#" onClick={handleClickShare}>
          {label}
        </Link>
      ) : (
        <Link to={to}>{label}</Link>
      )}
      {getOpenModal && (
        <PrintQR variant="none" getOpenModal={getOpenModal} closeModal={handleCloseModal}  />
      )}
    
    </li>
  );
};

const CintilloMonederoSears = () => (
  <section className='headBandNew'>
    <a href="https://www.sears.com.mx/c/historias/" target="_blank" className='headBandLink' rel="noreferrer">
      <span className="contentBandNew">
        <span className="firstText">Gana Hasta $150,000 pesos en monedero electrónico.</span>
        <span className="lastText">Cuéntanos tu historia de amor</span>
      </span>
    </a>
  </section>
)

const GiftsHeader = ({ shoppingCartProducts, createShoppingCart }) => {
  const [showMenu, updateMenu] = useState(false);
  const history = useHistory();
  const [showLogged, setShowLogged] = useState(false);
  const [showChangeGiftTable, setShowChangeGiftTable] = useState(false);
  const [newShoppingCart, setNewShoppingCart] = useState(false);
  const [storageGiftTable, setStorageGiftTable] = useStorage64Latin(
    CURRENT_GIFT_TABLE,
    {}
  );
  const { profileGet: profileData } = useUserInfo();
  const [currentGiftTable, dispatch] = useStore(
    (state) => state.giftTable.giftTable
  );
  const showInputInPaths = ['/my-info','/rsvp']
  // const showMenuInPaths = ['/my-table', '/agregar-regalos','/my-info','/rsvp']
  // menu Header raro
  const showMenuInPaths = ['/old/my-table', '/agregar-regalos-old','/regalos-recibidos-old','/buscar-evento-old','/my-info','/rsvp']

  const currentId = window.localStorage.getItem('profile_id');
  if (currentId && profileData.idClaro && +currentId !== +profileData.idClaro) {
    removeStorage(CURRENT_GIFT_TABLE);
    window.localStorage.setItem('profile_id', profileData.idClaro);
    window.location.reload();
  }
  window.localStorage.setItem('profile_id', profileData.idClaro);
  
  const [initialShoppingCartProducts] = useStore((state) =>
    _get(state, 'externalGiftTable.shoppingCart.results.list.products', [])
  );
  const [shoppingCartLength, setShoppingCartLength] = useState(
    shoppingCartProducts.length
  );
  const { hasGiftTableAndIsLogged } = useGiftTableInfo();

  const [initialShoppingCartLength, setInitialShoppingCartLength] = useState(0);

  const [, { isMobile }] = useWindowSize();
  const [show, setShow] = useState(false);
  const [target, setTarget] = useState(null);
  const [showSetting, setShowSetting] = useState(false);
  const ref = useRef(null);
  const cartRef = useRef(null);

  const handleClickSetting = (event) => {
    setShowSetting(!showSetting);
    setTarget(event.target);
    setShow(false);
  };

  const handleClick = (event) => {
    setShow(!show);
    setTarget(event.target);
    setShowSetting(false);
  };

  const onClickMenu = () => updateMenu(!showMenu);

  const handleClickEvent = () => {
    setShowChangeGiftTable(true);
  };

  const handleChangeGiftTable = (giftTable) => {
    // console.log('handleChangeGiftTable: ',giftTable)
    setStorageGiftTable(giftTable);
    setShowChangeGiftTable(false);

    if (!_isEmpty(currentGiftTable)) {
      encodeStorage('isChangedGiftTable', true);
      window.location.reload();
    }
  };

  useEffect(() => {
    if (!_isEmpty(storageGiftTable)) {
      // console.log('storageGiftTable es este al parecer: ',storageGiftTable)
      dispatch(setGiftTable(storageGiftTable));
    }
  }, [storageGiftTable]);

  useEffect(() => {
    //  console.log("Validando profileData.idClaro para activar header en modo invitado ",profileData.idClaro);
    if(profileData.idClaro === undefined){
      setShowLogged(!!localStorage.getItem('guest_email'));
    }else{
      setShowLogged(!!profileData.idClaro);
      //  Cerrar sesion de invitado
      localStorage.removeItem('guest_email');
      localStorage.removeItem('guest_phone_number');
      localStorage.removeItem('cart_id');
      // console.log('Eliminando datos de invitado');
    }
  }, [profileData]);

  // Menu Superior Flotante //
  const guestRouteInvitado = useRouteMatch({
    path: '/old/invitado/:eventId',
    exact: true
  });

  const guestRouteEventId = useRouteMatch({
    path: '/:eventId/:name',
    exact: true
  });

  const guestRouteEventIdOLD = useRouteMatch({
    path: '/:eventId/:name/old',
    exact: true
  });

  const guestRouteBuy = useRouteMatch({
    path: '/buy-gifts/old/:tableId/buy',
    exact: true
  });

  const guestRoutePaymentStepsFlow = useRouteMatch({
    path: '/old/payment-flow/:tableId/steps-flow',
    exact: true
  });

  useEffect(() => {
    setInitialShoppingCartLength(initialShoppingCartProducts.length);
  }, [initialShoppingCartProducts]);

  useEffect(() => {
    setNewShoppingCart(createShoppingCart);
  }, [createShoppingCart]);

  //  console.log("initialShoppingCartLength",initialShoppingCartLength,shoppingCartProducts.length);
  //  console.log("shoppingCartLength",shoppingCartLength,shoppingCartProducts.length);
  //  console.log("newShoppingCart",newShoppingCart);

  useEffect(() => {
    if (
      (shoppingCartProducts.length > initialShoppingCartLength &&
        shoppingCartProducts.length > shoppingCartLength) ||
      newShoppingCart
    ) {
      //  console.log("Entro a cartRef: ",cartRef);
      setShow(true);
      setTarget(cartRef.current);
      setShowSetting(false);
      const { offsetTop } = cartRef.current;
      window.scroll({
        top: offsetTop,
        behavior: 'smooth'
      });
    }
    setShoppingCartLength(shoppingCartProducts.length);
    setInitialShoppingCartLength(shoppingCartProducts.length);
    setNewShoppingCart(false);
  }, [shoppingCartProducts]);

  // Menu Superior Flotante //
  const onlyLadingGuest =
    // guestRouteEventId ||
    guestRouteEventIdOLD ||
    guestRouteInvitado ||
    guestRouteBuy ||
    guestRoutePaymentStepsFlow;
  const handleClose = () => setShow(false);

  return showLogged ? (
    <>
      <ListGiftsRecived show={isMobile && show} onClose={handleClose} />

      <ChangeGiftTable
        show={showChangeGiftTable}
        setShow={() => setShowChangeGiftTable(!showChangeGiftTable)}
        onChangeGiftTable={handleChangeGiftTable}
        currentGiftTable={currentGiftTable}
      />

      {
        !isMobile ? (
          <CintilloMonederoSears />
        ) :  showInputInPaths.includes(history.location.pathname) && (
          <div className='search-event-container'>
            <input name='searchEvent' className='search-input' placeholder = 'Buscar evento'/>
            <Link className='search-icon-container' to='/buscar-evento'>
              <img src = {searchIcon} className='search-icon'/>
            </Link>
          </div>
        )
      }

      {showLogged && onlyLadingGuest && (
          isMobile ?  (
            <div 
              style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}
            >

                <div
                  onClick={handleClickSetting}
                  onKeyPress={handleClickSetting}
                  tabIndex={0}
                  role="button"
                  className='menu-mobile ml-2'
                >
                  <img
                    src={iconHamburger}
                    alt=""
                    className="GiftsHeader__giftSetting mr-md-3"
                  />
                </div>
                <div
                    ref={cartRef}
                    className="GiftsHeader__giftmenu mr-2"
                    onClick={handleClick}
                    onKeyPress={handleClick}
                    tabIndex={0}
                    role="button"
                >
                  <i className="fa fa-gift fa-2x"><span className="badge badge-success contCart">{shoppingCartLength}</span></i>
                  <div ref={cartRef} />
                </div>
                
   
                {/*! onlyLadingGuest && (
                  <div
                    ref={cartRef}
                    className="GiftsHeader__giftmenu"
                    onClick={handleClick}
                    onKeyPress={handleClick}
                    tabIndex={0}
                    role="button"
                  >
                    <img src={shoppingCartIcon} alt="Carrito de compras" />
                    <span className="GiftsHeader__giftlabel">
                      Regalos ({shoppingCartLength})
                    </span>
                    <div ref={ref} />
                  </div>
                ) */}

                 <SettingOptionPopoverMovi  show={showSetting} setShow={setShowSetting} onlyLadingGuest = {onlyLadingGuest} />
              
              </div>
          ) : (
            //  OCUALTA SECCION EN agrega-invitados-excel
            !history.location.pathname.startsWith('/agrega-invitados-excel/') && (
            <Navbar expand="lg" className="GiftsHeader containerPortal">
              <Navbar.Brand>
                <a className="link-button mb-3 d-inline-block" href="/Mesa-de-Regalos/crear-mesa">
                  <Button block lg variant="primary">
                    Crear mesa
                  </Button>
                </a>
              </Navbar.Brand>
              <Nav.Link href="/Mesa-de-Regalos/faqs" style={{color:'#000'}}>Preguntas Frecuentes</Nav.Link>
              <Nav.Link href="/Mesa-de-Regalos/review" style={{color:'#000'}}>Reseñas</Nav.Link>
              <Navbar.Toggle />
              <Navbar.Collapse className="justify-content-end">
                <div
                    ref={cartRef}
                    className="GiftsHeader__giftmenu"
                    onClick={handleClick}
                    onKeyPress={handleClick}
                    tabIndex={0}
                    role="button"
                >
                  <i className="fa fa-gift fa-2x"><span className="badge badge-success contCart">{shoppingCartLength}</span></i>
                  <div ref={ref} />
                </div>
                {showSetting && (
                  <SettingOptionPopover target={target} show={showSetting} />
                )}
                {show && !isMobile && (
                  <ShoppingCartPopover ref={ref} target={target} show={show} />
                )}
              </Navbar.Collapse>
            </Navbar>
            )
          )
      )}
      
      {!onlyLadingGuest && showMenuInPaths.includes(history.location.pathname) && (
      <nav className="GiftsHeader ">
        <div className="container container-fluid d-flex justify-content-center nav-container-mobile">
          {!onlyLadingGuest && (
            <>
            {/*   INICIO    MENU ENGRANE                  */}
            {<div>
                {!onlyLadingGuest && (
                <div
                  onClick={handleClickSetting}
                  onKeyPress={handleClickSetting}
                  tabIndex={0}
                  role="button"
                  className='menu-mobile'
                >
                  <img
                    src={iconHamburger}
                    alt=""
                    className="GiftsHeader__giftSetting mr-md-3"
                  />
                  <div ref={cartRef} />
                </div>
                )}
                {/*! onlyLadingGuest && (
                  <div
                    ref={cartRef}
                    className="GiftsHeader__giftmenu"
                    onClick={handleClick}
                    onKeyPress={handleClick}
                    tabIndex={0}
                    role="button"
                  >
                    <img src={shoppingCartIcon} alt="Carrito de compras" />
                    <span className="GiftsHeader__giftlabel">
                      Regalos ({shoppingCartLength})
                    </span>
                    <div ref={ref} />
                  </div>
                ) */}
              </div>}
              {
                isMobile && <SettingOptionPopoverMovi  show={showSetting} setShow={setShowSetting} />
              }
              {showSetting && (
                <>
                  {
                    !isMobile && <SettingOptionPopover target={target} show={showSetting} />
                  }
                </>
              )}
              {show && !isMobile && (
                <ShoppingCartPopover ref={ref} target={target} show={show} />
              )}
              {/*   FIN    MENU ENGRANE                  */}
              {!isMobile && (
                currentGiftTable.evento && (
                  <button
                  type="button"
                  className="GiftsHeader__menubutton"
                  onClick={onClickMenu}
                >
                  <img src={iconHamburger} alt="" />
                </button>
                )
              )}
              <ul className={showMenu ? 'GiftsHeader--showmenu' : ''}>
                {hasGiftTableAndIsLogged &&
                  MENU_LINKS.map((item) => (
                    <HeaderMenuLink
                      key={item.id}
                      to={item.link}
                      label={item.caption}
                      division={item.division}

                      
                    />
                  ))}
              </ul>

              <div>
                {currentGiftTable.evento && ( 
                  <ChangeGiftTableList
                    show={false}
                    setShow={() => setShowChangeGiftTable(false)}
                    onChangeGiftTable={handleChangeGiftTable}
                    currentGiftTable={currentGiftTable}
                  />
                 )}
              </div>

              {/*         SECCION SELECCIONA MESA DESDE PORTAL SEARS      */}
              <div className="GiftsHeader__eventnumber">
                {currentGiftTable.evento && (
                  <>
                  <div
                    id="GiftsHeader__eventnumber_button"
                    onClick={handleClickEvent}
                    onKeyDown={handleClickEvent}
                    tabIndex="0"
                    role="button"
                  >
                    {/* Mesa #{currentGiftTable.evento}{' '}
                    <img src={arrow} alt="Lista de evento" className="event_arrow" /> */}
                  </div>
                  </>
                )}
              </div>
            </>
          )}
        </div>
      </nav>
      )}
    </>
  ) : (
    <CintilloMonederoSears />
  );
};

export default withStore({
  mapStateToProps: (state) => ({
    shoppingCartProducts: state.externalGiftTable.shoppingCartProducts.data,
    createShoppingCart: state.externalGiftTable.createShoppingCart.success
  })
})(GiftsHeader);
